import { cn } from "@/shared/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        // 浅色皮肤走 token(bg-muted + pulse);cyber 的深色霓虹微光由 skin-cyber.css `.cyber-skeleton` 还原
        "cyber-skeleton relative overflow-hidden rounded-md bg-muted animate-pulse",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
